module.exports = __webpack_public_path__ + "I2U1@2x.jpg?1585063ad34c2038922341a4d563cb9e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/I2U1@2x.jpg
// module id = 94
// module chunks = 0